import AlarmSetting from './pages/AlarmSetting';
import Laboratory from './pages/Laboratory';
import MyPersonalization from './pages/MyPersonalization';
import PointOfContact from './pages/PointOfContact';
import type { ScreenItem } from 'shared/src/types';
import { WEB_ROUTE_PATHS } from 'shared/src/webRoutePaths';

export const MyPageScreens: ScreenItem[] = [
  {
    name: 'AlarmSetting',
    component: AlarmSetting,
    path: WEB_ROUTE_PATHS.AlarmSetting,
    options: {
      title: '알림 설정',
    },
  },
  {
    name: 'Laboratory',
    component: Laboratory,
    path: WEB_ROUTE_PATHS.Laboratory,
    options: {
      title: '실험실',
    },
  },
  {
    name: 'MyPersonalization',
    component: MyPersonalization,
    path: WEB_ROUTE_PATHS.MyPersonalization,
    options: {
      title: '맞춤 정보',
    },
    convertParams: props => {
      const extras = Array.isArray(props.extras)
        ? props.extras[0]
        : props.extras;

      return {
        instanceId: props.instanceId,
        ...(typeof extras === 'string' ? JSON.parse(extras) : extras),
      };
    },
  },
  {
    name: 'PointOfContact',
    component: PointOfContact,
    path: WEB_ROUTE_PATHS.PointOfContact,
    options: {
      title: '상담 그룹 등록',
    },
  },
];
